import { Container, Row, Col } from "react-bootstrap";
import "./ProductSection.css";
import WhiteButton from "../../common_components/common_button/WhiteButton";
import { useNavigate } from "react-router-dom";
import { getProduct } from "../../../features/admin/product/productdetails/Slice";
import { useDispatch, useSelector } from "react-redux";
import { useContext, useEffect, useState } from "react";
import { IDS } from "../../../utils/IDS";
import { Context } from "../../../utils/context";
import Cookies from "js-cookie";
import BuyModal from "../../common_components/common_modal/buy_now_modal/Buy_Modal";
import { GETProfile } from "../../../features/admin/auth/Slice";

function ProductSection() {
  const dispatch = useDispatch();

  const { userdata } = useContext(Context);
  

  const productsdetails = useSelector((state) => state.product.productdetails);

  const products = productsdetails?.products;
  const productdetail = productsdetails?.products?.productdetails;

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  useEffect(() => {
    dispatch(getProduct());
  }, [dispatch]);

  const [showBuyModal, setShowBuyModal] = useState(false);

  const navigate = useNavigate();

  // const handleBuyNow = () => {
  //   Cookies.remove("shippingData");
  //   Cookies.remove("orderData");

  //   navigate("/cart");
  // };

  const handleBuyNow = () => {
    const isProfileComplete = userdata?.name && userdata?.email;

    if (!isProfileComplete) {
      setShowBuyModal(true);
      return;
    }

    Cookies.remove("shippingData");
    Cookies.remove("orderData");

    navigate("/cart");
  };

  return (
    <section className="product-section">
      <img
        src="images\home\productsection\leftSide.png"
        alt="not"
        className="side-image side-image-left"
      />

      <img
        src="images\home\productsection\rightSide.png"
        alt="not"
        className="side-image side-image-right"
      />

      <Container>
        <div className="product-container">
          <Row className="align-items-center">
            {/* Left Side  */}
            <Col lg={5} md={12} sm={12} className="text-center">
              <img
                // src="/images/home/productsection/product.png"
                src={`${IDS.IMG_URL}${products?.image}`}
                alt="Spirulina"
                className="product-img"
              />
            </Col>

            {/* Right Side  */}
            <Col lg={7} md={12} sm={12}>
              <div className="product-content">
                <div className="bg-box">
                  {/* <h2>Spirulina Superfood Supplement</h2> */}
                  <h2>{products?.name}</h2>
                  <p className="subtitle">
                    {/* Pure Nutrition For Everyday Wellness */}
                    {htmlToReactParser.parse(products?.description)}
                  </p>

                  <p className="price">
                    <div className="dot"></div>₹ {products?.price}/-{" "}
                    <span>Only</span>
                  </p>
                </div>
                <ul className="product-details">
                  <li>Form: {productdetail?.form}</li>
                  <li>Net Quantity: {productdetail?.quantity} Tablets</li>
                  <li>Suitable For: {productdetail?.suitable}</li>
                  <li>Usage: {productdetail?.usage}</li>
                </ul>

                {/* {userdata?.order?.length === 0 ? ( */}
                {/* <WhiteButton
                  title={"Buy Now"}
                  bg="#ffff"
                  color="#000"
                  hoverColor="#f35f37"
                  hoverBg={"#000"}
                  onClick={() => navigate("/cart")}
                /> */}
                <WhiteButton
                  title={"Buy Now"}
                  bg="#ffff"
                  color="#000"
                  hoverColor="#f35f37"
                  hoverBg={"#000"}
                  onClick={handleBuyNow}
                />
                {/* ) : (
                  <p className="already-purchased-text">
                    You have already purchased this product.
                  </p>
                )} */}
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <BuyModal
        show={showBuyModal}
        handleClose={() => {
          setShowBuyModal(false);

          navigate("/profile-settings");
        }}
      />
    </section>
  );
}

export default ProductSection;
